// extracted by mini-css-extract-plugin
module.exports = {"checked":"check_checked__NGhX-"};